import BaseAPI from "./BaseAPI";

class AuthAPI extends BaseAPI {
  // Login API
  async loginAPI(values) {
    const req = {
      url: "login/crm",
      method: "POST",
      data: {
        userName: values.name,
        password: values.password,
      },
    };
    return await this.makeRequest(req);
  }

  // Verify API
  async verifyOTPAPI(values, userID) {
    const req = {
      url: "login/verfication/otp",
      method: "POST",
      data: {
        otp: values.otp,
        userID: userID,
      },
    };
    return await this.makeRequest(req);
  }

  // Forgot Password API
  async forgotPasswordAPI(values) {
    const req = {
      url: "login/forgot-password",
      method: "POST",
      data: {
        userName: values.userName,
      },
    };
    return await this.makeRequest(req);
  }

  // Change Password API
  async changePasswordAPI(values, userID) {
    const req = {
      url: "login/update-password",
      method: "POST",
      data: {
        newPassword: values.password,
        confirmPassword: values.confirmPassword,
        otp: values.otp,
        userID: userID,
      },
    };
    return await this.makeRequest(req);
  }

  // Auto Login API
  async autoLoginAPI(params) {
    const req = {
      url: "login/user-login-validation",
      method: "POST",
      data: {
        code: params,
      },
    };
    return await this.makeRequest(req);
  }
  // Logout API
  async logoutAPI(token) {
    const req = {
      url: "login/logout",
      method: "POST",
      ...(token && { headers: { Authorization: `Bearer ${token}` } }),
    };
    return await this.makeRequest(req);
  }
}

export default AuthAPI;
